module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1c63c503911067b0a2e97a69631bbc40.png";